import React from 'react';
import { Link } from 'react-router-dom'

const ImageTruck = (props) => {
    return (
        <Link to={props.href}>
            <div className="Truck">
                <img src={props.image} alt="Image" width="250" />
            </div>
            <div style={{ display:'flex',justifyContent: 'center' }} >
             {props.text}
            </div>
        </Link>
    )
}
export default ImageTruck;